export default function metadataToInputMetadata(
    metadata: {
        field: {
            name: string;
        };
        value: string;
    }[],
) {
    return metadata.map((metadataValue) => ({
        fieldName: metadataValue.field.name,
        value: metadataValue.value,
    }));
}
